import { configureStore } from '@reduxjs/toolkit'
import companyReducer from "./slices/company";
import authReducer from "./slices/authSlice";

export default configureStore({
  reducer: {
    company: companyReducer,
    auth: authReducer
  },
})